<script setup lang="ts">
import { computed } from 'vue';
import type { AIValidationStatus } from '@/types/v2/Document';

const props = defineProps<{
  status?: AIValidationStatus;
  resultId?: number | null;
}>();

const STATUS_DISPLAY = {
  validated: { label: 'Validated', colorClass: 'text-green-700' },
  unvalidated: { label: 'Unvalidated', colorClass: 'text-amber-700' },
} as const;

const display = computed(() =>
  props.status === 'validated' || props.status === 'unvalidated' ? STATUS_DISPLAY[props.status] : null,
);
</script>

<template>
  <router-link
    v-if="display && resultId != null"
    :to="{ path: '/ai-results', query: { resultId } }"
    :class="[display.colorClass, 'hover:underline']">
    {{ display.label }}
  </router-link>
</template>
